/* eslint-disable no-lonely-if */
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty, isIn, isEmail } from 'validator';
import { Link } from 'react-router-dom';
import moment from 'moment';
import swal from 'sweetalert2';
import {
    validateInput, changeStep, getPicklist, updateRegistrationData, resetRegistration, saveAsDraft,
} from '../actions';
import { validateNRIC } from '../../../../utils/common';
import Address from './Address';
import PersonalContact from './PersonalContact';
import { getPostaCodeOptions } from '../../actions/common';
import PersonalDetails from './PersonalDetails';


class Tab2 extends React.Component {
    constructor(props) {
        super(props);
        const tab2 = props.tab2 ? {
            ...props.tab2,
            Date_of_Birth__c: moment(props.tab2.Date_of_Birth__c),
        } : {};
        this.state = {
            form: tab2,
            errorMessage: {},
            postalCodeList: [],
        };
        this.onInputChanged = this.onInputChanged.bind(this);
        this.validateInput = validateInput.bind(this);
        this.validationList = this.validationList.bind(this);
        this.postaCodeOptions = this.postaCodeOptions.bind(this);
    }

    componentWillMount() {
        this.props.changeStep(1);
    }

    async onInputChanged(e, fieldName = null) {
        const { form } = this.state;
        if (fieldName !== null) {
            form[fieldName] = e;
            if (fieldName === 'Postal__c') {
                if (e === null) {
                    form.Postal__c = null;
                    form.Street__c = null;
                    form.Block__c = null;
                } else {
                    form.Postal__c = e.POSTCODE.toString();
                    form.Street__c = e.STREETNAME.toString();
                    form.Block__c = e.BLDGNO.toString();
                }
                form.Country__c = 'Singapore';
            }
        } else {
            if (e.target.name === 'ID_Type__c') {
                form.Nationality__c = e.target.value === 'Others' ? 'Others' : form.Nationality__c;
            }
            form[e.target.name] = e.target.value;
        }
        this.setState({ form });
        this.validateInput(this.validationList());
    }

    validationList() {
        const { form } = this.state;
        return {
            Full_Name__c: {
                message: 'Full name is required',
                validate: val => !isEmpty(val || ''),
            },
            ID_Type__c: {
                message: 'ID Type required',
                validate: val => !isEmpty(val || '') && !isIn(val, getPicklist('ID_Type__c', this.props.objectInfo.Person__c)),
            },
            ID_Number__c: {
                message: 'Invalid FIN or NRIC',
                validate: val => (form.ID_Type__c !== 'Others' ? validateNRIC(val || '') : !isEmpty(val || '')),
            },
            Date_of_Birth__c: {
                validate: (val) => {
                    const yearDiff = moment().diff(val, 'years');
                    return yearDiff >= 18;
                },
                message: 'Applicant should be and adult with minimum age 18 years old',
            },
            Marital_Status__c: { validate: val => !isEmpty(val || '') },
            Other_Marital_Status__c: {
                validate: val => (form.Marital_Status__c === 'Others' ? !isEmpty(val || '') : true),
            },
            // Gender__c: { validate: val => !isEmpty(val || '') },
            Nationality__c: { validate: val => !isEmpty(val || '') },
            Other_Nationality__c: {
                validate: val => (form.Nationality__c === 'Others' ? !isEmpty(val || '') : true),
            },
            // Race__c: { validate: val => !isEmpty(val || '') },
            // Other_Race__c: {
            //     validate: val => (form.Race__c === 'Others' ? !isEmpty(val || '') : true),
            // },
            Postal__c: {
                validate: val => /\d{6}/g.test(val ? val.toString() : ''),
                message: 'Invalid postal code',
            },
            Street__c: { validate: val => !isEmpty(val || '') },
            Block__c: { validate: val => !isEmpty(val || '') },
            Unit_Number__c: { validate: val => !isEmpty(val || '') },
            Flat_Type__c: { validate: val => !isEmpty(val || '') },
            Other_Flat_Type__c: { validate: val => (form.Flat_Type === 'Others' ? !isEmpty(val || '') : true) },
            // Country__c: { validate: val => !isEmpty(val || '') },
            Contact_Number__c: {
                validate: val => /[6|8|9]\d{7}|\+65[6|8|9]\d{7}|\+65\s[6|8|9]\d{7}/g.test(val ? val.toString() : ''),
                message: 'Invalid mobile phone number',
            },
            Mobile_Phone__c: {
                validate: val => /[6|8|9]\d{7}|\+65[6|8|9]\d{7}|\+65\s[6|8|9]\d{7}/g.test(val ? val.toString() : ''),
                message: 'Invalid mobile phone number',
            },
            Office_Phone__c: {
                validate: val => /[6|8|9]\d{7}|\+65[6|8|9]\d{7}|\+65\s[6|8|9]\d{7}/g.test(val ? val.toString() : '') || isEmpty(val || ''),
                message: 'Invalid office number',
            },
            Home_Phone__c: {
                validate: val => /[6|8|9]\d{7}|\+65[6|8|9]\d{7}|\+65\s[6|8|9]\d{7}/g.test(val ? val.toString() : '') || isEmpty(val || ''),
                message: 'Invalid homephone number',
            },
            Email_Address__c: {
                validate: val => isEmpty(val || '') || isEmail(val || ''),
                message: 'Invalid email address',
            },
        };
    }

    async postaCodeOptions(value) {
        const postalCodeList = await getPostaCodeOptions(value);
        this.setState({ postalCodeList });
    }

    render() {
        const { form, errorMessage } = this.state;
        const { objectInfo } = this.props;
        return (
            <div className="col-md-12 print">
                <PersonalDetails
                    form={form}
                    objectInfo={objectInfo}
                    onInputChanged={this.onInputChanged}
                    errorMessage={errorMessage}
                />
                <Address
                    getPostaCodeOptions={getPostaCodeOptions}
                    form={form}
                    objectInfo={objectInfo}
                    onInputChanged={this.onInputChanged}
                    errorMessage={errorMessage}
                />
                <PersonalContact
                    form={form}
                    objectInfo={objectInfo}
                    onInputChanged={this.onInputChanged}
                    errorMessage={errorMessage}
                />
                <div className="text-center">
                    <div className="btn-group">
                        <Link
                            to="/step-0"
                            key="prev-tab2"
                            className="btn btn-md btn-warning btn-fill "
                            onClick={() => window.scrollTo({ top: 0 })}
                        >
                            <i className="fa fa-arrow-left" />
                            Previous
                        </Link>
                        <a href={null} type="reset" className="btn btn-info btn-fill" onClick={this.props.resetRegistration}>
                            <i className="fa fa-refresh" /> Clear Form
                        </a>
                        <a
                            href={null}
                            className="btn btn-md btn-inverse btn-fill "
                            onClick={(e) => {
                                document.querySelector('.main-panel').scrollTop = 300;
                                const isPassed = this.validateInput(this.validationList(), true);

                                if (!isPassed) {
                                    e.preventDefault();
                                    swal.fire({
                                        title: 'Incomplete form',
                                        text: 'Please validate all data before saving.',
                                        type: 'warning',
                                    });
                                } else {
                                    this.props.updateRegistrationData('2', this.state.form);
                                    this.props.saveAsDraft();
                                }
                            }}
                        >
                            <i className="fa fa-save" />
                            Save as Draft
                        </a>
                        <Link
                            to="/step-2"
                            key="next-tab2"
                            className="btn btn-md  btn-primary btn-fill"
                            onClick={(e) => {
                                // e.preventDefault();
                                document.querySelector('.main-panel').scrollTop = 300;
                                const isPassed = this.validateInput(this.validationList(), true);
                                
                                if (!isPassed) e.preventDefault();
                                else {
                                    this.props.updateRegistrationData('2', this.state.form);
                                }
                            }}
                        >
                            Next
                            <i className="fa fa-arrow-right" />
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

Tab2.propTypes = {
    changeStep: PropTypes.func.isRequired,
    objectInfo: PropTypes.object.isRequired,
    updateRegistrationData: PropTypes.func.isRequired,
    resetRegistration: PropTypes.func.isRequired,
    tab2: PropTypes.object.isRequired,
    saveAsDraft: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeStep,
        updateRegistrationData,
        resetRegistration,
        saveAsDraft,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    currentStep: state.registration.currentStep,
    tab2: state.registration.tab2,
    objectInfo: state.objectInfo,
});


export default connect(mapStateToProps, mapDispatchToProps)(Tab2);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/Tab2/index.js
// module id = 1010
// module chunks = 0